<template>
  <div>
    <h1>Create an offer</h1>

    <form class="mt-4" @submit.prevent="createOffers">

      <div class="form-group">
        <label for="parent">
          <small class="text-muted">PRODUCT</small>
        </label>
        <select
          class="form-control"
          name="parent"
          v-model="product_id"
          :disabled="loading"
        >
          <option
            v-for="product in products"
            :key="product.id"
            :value="product.id"
          >
            {{ product.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>
          <small class="text-muted">Start Date</small>
        </label>
        <input
          type="text"
          class="form-control"
          :placeholder="Start"
          v-model="start"
          required
          autofocus
          :disabled="loading"
        />
      </div>

      <div class="form-group">
        <label>
          <small class="text-muted">End Date</small>
        </label>
        <input
          type="text"
          class="form-control"
          :placeholder="End"
          v-model="end"
          required
          autofocus
          :disabled="loading"
        />
      </div>

      <div class="form-group">
        <label>
          <small class="text-muted">New Price</small>
        </label>
        <input
          type="Number"
          class="form-control"
          :placeholder="new_price"
          v-model="new_price"
          required
          autofocus
          :disabled="loading"
        />
      </div>

      <div class="form-group">
        <label>
          <small class="text-muted">Notes</small>
        </label>
        <input
          type="text"
          class="form-control"
          :placeholder="note"
          v-model="notes"
          required
          autofocus
          :disabled="loading"
        />
      </div>

      <button
        type="submit"
        class="btn btn-primary ld-ext-right mt-3"
        :disabled="loading"
        :class="{ running: loading }"
      >
        {{ loading ? "Creating…" : "Create" }}
        <div class="ld ld-ring ld-spin" />
      </button>
    </form>

    <div class="alert alert-danger mt-4" v-if="!loading && error">
      <p class="mb-0 text-center">
        {{ error }}
      </p>
    </div>
  </div>
</template>


<script>
import { getError } from "../../../helpers";
import FileInput from "../../FileInput";
import store from "../../../store";
import { mapState } from "vuex";

export default {
  components: {
    "file-input": FileInput,
  },

  data() {
    return {
      product_id: null,
      start: "",
      end: "",
      new_price: "",
      notes: "",
      loading: false,
      error: "",
    };
  },

  methods: {
    createOffers() {
      this.loading = true;

      this.$store
        .dispatch("offers/create", {
          product_id: this.product_id,
          start: this.start,
          end: this.end,
          new_price: this.new_price,
          notes: this.notes,
        })
        .then(() => {
          this.$router.push({ name: "offers" });
        })
        .catch((e) => {
          this.error = getError(e);
          this.loading = false;
        });
    },
  },

  computed: {
    ...mapState({
      products: (state) => state.products.products.filter(c=>c.active == 1),
    }),
  },

  async beforeRouteEnter(to, from, next) {
    await store.dispatch("products/fetchAll");
    next((vm) => {
      if (to.query.parent) vm.parent_id = to.query.parent;
    });
  },

  meta: {
    title: "Create an offer item",

    meta: [{ property: "og:title", content: "Create an offer item / Shayah" }],
  },
};
</script>
